import { redirect } from 'react-router-dom'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

export const legacySpendingProductsRedirectRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.expenses.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.expenses.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/expenses/,
              navigation.finance.spending.expenses.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.procurement.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.procurement.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/procurement/,
              navigation.finance.spending.procurement.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.software.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.software.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/software/,
              navigation.finance.spending.software.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
  ]
}

export const legacyFinanceRedirectRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.finance.invoices.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.invoices.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/invoices/,
              navigation.finance.spending.invoices.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.cards.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.treasury.banking.cards.fullPath()),
        },
        {
          path: navigation.finance.cards.new.path,
          loader: () => redirect(navigation.finance.spending.expenses.new_card.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/cards/,
              navigation.finance.treasury.banking.cards.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.banking.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.treasury.banking.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/banking/,
              navigation.finance.treasury.banking.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.contacts.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.vendors.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/contacts/,
              navigation.finance.spending.vendors.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.vendors.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.spending.vendors.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/vendors/,
              navigation.finance.spending.vendors.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.clients.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.sales.clients.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/clients/,
              navigation.finance.sales.clients.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
    {
      path: navigation.finance.financial_workspace.path,
      children: [
        {
          index: true,
          loader: () => redirect(navigation.finance.financialWorkspace.fullPath()),
        },
        {
          path: '*',
          loader: ({ request }) => {
            const url = new URL(request.url)
            const newPath = url.pathname.replace(
              /^\/finance\/financial_workspace/,
              navigation.finance.financialWorkspace.fullPath()
            )
            return redirect(`${newPath}${url.search}${url.hash}`)
          },
        },
      ],
    },
  ]
}
